BR.ExportProfile = L.Class.extend({
    latLngs: [],

    options: {
        shortcut: {
            export: 88, // char code for 'x'
        },
    },

    initialize: function (router, pois, profileParam) {
console.log("ExportProfile  start initialize..........\n");
        this.profileVar = profileParam;
        this.router = router;
        this.pois = pois;
        this.navbarProfilesDropdown = $('#navbarProfilesDropdown');

console.log("ExportProfile  ONCLICK ... vor exportProfileButton..\n");
      L.DomUtil.get('navbarProfilesDropdown').onclick = L.bind(this._generateProfilename, this);
          
console.log("ExportProfile ONCLICK ... nach exportProfileButton..\n");
        L.DomUtil.get('submitExportProfile').onclick = L.bind(this._exportProfile, this);

console.log("ExportProfile ONCLICK ... nach clearStartupProfile button..\n");
        L.DomUtil.get('clearStartupProfile').onclick = L.bind(this._clearStartupProfile, this);
  
       L.DomEvent.addListener(document, 'keydown', this._keydownListener, this);
console.log("ExportProfile this._keydownListener VOR update name...");
        this.update([]);
    },

    update: function (latLngs) {

console.log("ExportProfile  nothing to do here"); 
    },


  _clearStartupProfile: function (e) {

      localStorage.removeItem("BrouterStartProfile");
      localStorage.removeItem("BrouterStartProfileName");
      BR.message.showInfo(i18next.t('export.reset_profiletodefault')); 
        
 },

//   export profile 
    _exportProfile: function (e) {

   var exportForm = document.forms['profiles'];
   var profileStoreName = exportForm['htmlProfileName'].value;

 var profile = $('#profile option:selected');
 var profileName = profile.val();
console.log("Profile_Name=" + profileName );

// 
    var BaseUri  =  BR.conf.profilesUrl;
          if ( profileName.substring(0, 6) === 'custom') 
               {
               uri = BaseUri.replace("/profiles2/", "/customprofiles/") +  profileName.substring(7) + '.brf';
//  special case Serge
               uri = uri.replace("serge.etges.eu", "brouter.de/brouter") ;
               }
             else
               { uri = BR.conf.profilesUrl + profileName + '.brf';}
           
console.log("Download Profile CURRENT:" + uri);
        e.preventDefault();

        var evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        var link = document.createElement('a');
        link.href = uri;
// SET a specific file name 
        link.download= profileStoreName + ".brf";
        link.dispatchEvent(evt);
    },



    _validationMessage: function () {
        var profilename = this.profilename;
        var replaceRegex = new RegExp('[^' + this.profilenameAllowedChars + ']', 'g');

        if (profilename.validity.patternMismatch) {
            var replaced = profilename.value.replace(replaceRegex, '');
            var patternStr = this.profilenameAllowedChars.replace(/\\/g, '');
            this.profilenameMessage.textContent = '[' + patternStr + '] --> ' + replaced;
        } else {
            this.profilenameMessage.textContent = '';
        }
    },

    _generateProfilename: function () {

 var profile = $('#profile option:selected');
 var profileName = profile.val();

console.log("ExportProfile  _generateProfilename...profileName=" + profileName);


    var exportForm = document.forms['profiles'];
    exportForm['htmlProfileName'].value = profileName;

    },

 
    _keydownListener: function (e) {
        if (
            BR.Util.keyboardShortcutsAllowed(e) &&
            e.keyCode === this.options.shortcut.export &&
            !this.exportProfileButton.hasClass('disabled')
        ) {
console.log(" ExportProfile generate profile name!!");

            this._generateProfilename();
            $('#export').modal('show');
        }
    },
});
